import React, {FC, PropsWithChildren} from 'react';
import {PageContentWrapper} from '../page-content-wrapper/page-content-wrapper.component';

export const Modal: FC<PropsWithChildren> = ({children}) => (
  <div className="absolute w-full h-full bg-gray-300 bg-opacity-80 z-10">
    <div className="fixed bottom-0 w-full max-w-screen-md">
      <PageContentWrapper>{children}</PageContentWrapper>
    </div>
  </div>
);
